var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"}},[_c('nav-bar',{attrs:{"id":"navbar"}}),_vm._v(" "),_c('search-form'),_vm._v(" "),_c('div',{attrs:{"id":"maincontent"}},[_vm._t("default")],2),_vm._v(" "),_c('Footer',{attrs:{"id":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }